import React from 'react';

const SuratPerizinan = () => {
    return (
        <div className="container mx-auto px-4 py-12">
            <h1 className="text-3xl font-bold text-[#1E3A8A] mb-8">Surat Layanan Perizinan</h1>
            <div className="card-glass">
                <h2 className="text-xl font-bold text-[#0D9488] mb-4">Informasi Layanan Perizinan</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-blue-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-[#1E3A8A] mb-2">Perizinan Tersedia</h3>
                        <ul className="space-y-2">
                            <li className="flex items-center">
                                <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                <span className="text-gray-700">Izin Pemakaian Tanah</span>
                            </li>
                            <li className="flex items-center">
                                <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                <span className="text-gray-700">Izin Pemakaian Ruangan</span>
                            </li>
                            <li className="flex items-center">
                                <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                <span className="text-gray-700">Izin Sewa Aset</span>
                            </li>
                            <li className="flex items-center">
                                <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                                <span className="text-gray-700">Izin Penggunaan Gedung</span>
                            </li>
                        </ul>
                    </div>

                    <div className="bg-green-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-[#1E3A8A] mb-2">Dokumen Diperlukan</h3>
                        <ul className="list-disc list-inside space-y-1 text-gray-600">
                            <li>KTP Pemohon</li>
                            <li>NPWP (jika ada)</li>
                            <li>Proposal Penggunaan</li>
                            <li>Surat Pengantar</li>
                            <li>Dokumen Pendukung Lainnya</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SuratPerizinan;